import Tab from "../../../../../components/Tabs";
import dynamic from "next/dynamic";
import { useState, Suspense, FC } from "react";
import useStore from "../../../../../context/useStore";

const SitePlan = dynamic(() => import("./SitePlan"), {
  suspense: true,
});
const ProjectGallery = dynamic(() => import("./ProjectGallery"), {
  suspense: true,
});
const FloorPlan = dynamic(() => import("./FloorPlan"), {
  suspense: true,
});

interface Props {
  gallery: any;
  siteplan: any;
  floorplan: any;
}

const Index: FC<Props> = ({ siteplan, gallery, floorplan }) => {
  const [active, setActive] = useState<number>(1);
  const { auth, setDialog } = useStore();

  return (
    <>
      <div className="flex items-center justify-start gap-2 w-full border-b border-gray-400">
        <div className="bg-primary">
          <Tab
            className={` text-white !px-4 !py-2 text-sm hover:text-white ${
              active === 1 ? "mix-blend-screen" : ""
            } `}
            keynumber={1}
            onClick={() => {
              setActive(1);
            }}
            tab={"Project Gallery"}
          />
        </div>
        <div className="bg-primary">
          <Tab
            className={` text-white !px-4 !py-2 text-sm hover:text-white ${
              active === 2 ? "mix-blend-screen" : ""
            } `}
            keynumber={2}
            onClick={() => {
              setActive(2);
            }}
            tab={"Site Plan"}
          />
        </div>
        <div className="bg-primary">
          <Tab
            className={` text-white !px-4 !py-2 text-sm hover:text-white ${
              active === 3 ? "mix-blend-screen" : ""
            } `}
            keynumber={3}
            onClick={() => {
              setActive(3);
            }}
            tab={"Floor Plans"}
          />
        </div>
      </div>
      {active === 1 ? (
        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <ProjectGallery gallery={gallery} />
        </Suspense>
      ) : active === 2 ? (
        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          {" "}
          <SitePlan siteplan={siteplan} />
        </Suspense>
      ) : (
        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <div className="relative">
            {auth.login === false && (
              <div className="absolute w-full h-full top-0 right-0 z-50 flex justify-center items-center">
                <div className="rounded-md bg-black text-white bg-opacity-80 px-5 py-2">
                  <button
                    onClick={() => {
                      setDialog({
                        open: true,
                        closable: true,
                      });
                    }}
                    className="text-base font-normal"
                  >
                    Login Required To View Floor Plan
                  </button>
                </div>
              </div>
            )}
            <div className={auth.login === false ? "blur" : ""}>
              <FloorPlan floorPlan={floorplan} />
            </div>
          </div>
        </Suspense>
      )}
    </>
  );
};

export default Index;
